export var isChecked = function isChecked(value) {
  return typeof value === 'number';
};
export var isIndeterminate = function isIndeterminate(selected, unselected, partialSelected) {
  return selected.length > 0 && unselected.length > 0 || partialSelected.length > 0;
};
export var isExist = isChecked;